import ApiClient from "../client";
import { ApiInviteStaffPayload, ApiUserInline } from "../types";
export const inviteStaff = (
  client: ApiClient,
  payload: ApiInviteStaffPayload
) => {
  return client.post<ApiUserInline>("/accounts/invite-staff", payload);
};

export const endpoints = { inviteStaff };
